export enum EPublishStatus {
  PUBLISHED = 'PUBLISHED',
  UNPUBLISHED = 'UNPUBLISHED',
}

export enum EReceiverTypeAgent {
  isTraditionalAgents = 'isTraditionalAgents',
  isPruventure = 'isPruventure',
  isGroupOfUsers = 'isGroupOfUsers',
}

export enum EReferralForm {
  isName = 'isName',
  isPhone = 'isPhone',
  isProvinceCity = 'isProvinceCity',
  isDob = 'isDob',
  isEmail = 'isEmail',
}
